/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Thu May 22 2025
 **/

import { useTheme } from "@emotion/react";

import { _T } from "@rfice/language";
import { Menu } from "@/frameworks/designStuff";
import { usePopover } from "@/frameworks/core/hooks";
import { GROUP_POPOVER_ID } from "@/frameworks/core/commons";

interface CallMethodOptionProps {
	data: {
		[key: string]: {
			value: string;
			disabled: boolean;
		};
	};
	onClick: (e: React.MouseEvent<HTMLLIElement>) => void;
	popoverID: GROUP_POPOVER_ID;
}
export default function CallMethodOption({ data, onClick, popoverID }: CallMethodOptionProps) {
	const theme = useTheme();
	const popover = usePopover();

	return (
		<Menu
			data-role="call-method-option"
			css={{
				background: theme.colors.neutral_00_100
			}}
			onMouseLeave={() => {
				popover.hide(popoverID, "caller_call_method_option");
			}}
		>
			<Menu.List>
				<Menu.Header onClick={(e) => e.stopPropagation()}>{_T("전화하기")}</Menu.Header>
				<Menu.Item onClick={onClick} data-type="default" disabled={data["default"].disabled}>
					{_T("RFICE 안심콜")}
				</Menu.Item>
				<Menu.Item onClick={onClick} data-type="070" disabled={data["070"].disabled}>
					{data["070"].value}
				</Menu.Item>
			</Menu.List>
		</Menu>
	);
}
